import type { VenueData, VenueDetailData, VenueEditFormValues } from './types';

export const MODAL_BODY_STYLES: React.CSSProperties = {
  maxHeight: '85vh',
  overflowY: 'auto',
};

export const VENUE_EDIT_FORM_DEFAULT_VALUES: VenueEditFormValues = {
  _id: 'add_venue_temp_id',
  name: '',
  address: '',
  capacity: 0,
  operatingHours: [
    {
      day: 0,
      times: [],
      status: 'closed',
    },
    {
      day: 1,
      times: [],
      status: 'closed',
    },
    {
      day: 2,
      times: [],
      status: 'closed',
    },
    {
      day: 3,
      times: [],
      status: 'closed',
    },
    {
      day: 4,
      times: [],
      status: 'closed',
    },
    {
      day: 5,
      times: [],
      status: 'closed',
    },
    {
      day: 6,
      times: [],
      status: 'closed',
    },
  ],
};

// TODO: 從這之下都是假資料，記得改用真實資料，並移除假資料
export const DUMMY_VENUE_LIST: VenueData[] = [
  {
    _id: '1',
    name: '娛樂室',
    address: '桃園市桃園區日光路330號88號1樓之2',
    capacity: 30,
  },
  {
    _id: '2',
    name: '會議室',
    address: '桃園市桃園區日光路330號88號3樓之2',
    capacity: 30,
  },
  {
    _id: '3',
    name: '演播廳',
    address: '桃園市桃園區日光路330號88號4樓之2',
    capacity: 30,
  },
];

export const DUMMY_VENUE_DETAIL: VenueDetailData = {
  _id: '1',
  name: '娛樂室',
  address: '桃園市桃園區日光路330號88號1樓之2',
  capacity: 30,
  operatingHours: [
    {
      day: 0,
      times: ['09:00-12:00', '15:00-18:00', '21:00-23:00'],
      isAllDayOpen: false,
      isDisabled: false,
    },
    {
      day: 1,
      times: [],
      isAllDayOpen: true,
      isDisabled: false,
    },
    {
      day: 2,
      times: [],
      isAllDayOpen: false,
      isDisabled: true,
    },
    {
      day: 3,
      times: ['07:00-10:30', '13:45-16:30', '19:30-21:00'],
      isAllDayOpen: false,
      isDisabled: false,
    },
    {
      day: 4,
      times: [],
      isAllDayOpen: true,
      isDisabled: false,
    },
    {
      day: 5,
      times: ['06:00-09:30', '11:00-13:30', '15:15-17:15', '18:30-20:30'],
      isAllDayOpen: false,
      isDisabled: false,
    },
    {
      day: 6,
      times: [],
      isAllDayOpen: false,
      isDisabled: true,
    },
  ],
};

export const DUMMY_VENUE_EDIT_VALUES: VenueEditFormValues = {
  _id: '1',
  name: '娛樂室',
  address: '桃園市桃園區日光路330號88號1樓之2',
  capacity: 30,
  operatingHours: [
    {
      day: 0,
      times: [
        {
          startTime: 9,
          endTime: 12,
        },
        {
          startTime: 15,
          endTime: 18,
        },
        {
          startTime: 21,
          endTime: 23,
        },
      ],
      status: 'open',
    },
    {
      day: 1,
      times: [],
      status: 'allDay',
    },
    {
      day: 2,
      times: [],
      status: 'closed',
    },
    {
      day: 3,
      times: [
        {
          startTime: 7,
          endTime: 10,
        },
        {
          startTime: 13,
          endTime: 16,
        },
        {
          startTime: 19,
          endTime: 21,
        },
      ],
      status: 'open',
    },
    {
      day: 4,
      times: [],
      status: 'allDay',
    },
    {
      day: 5,
      times: [
        {
          startTime: 6,
          endTime: 9,
        },
        {
          startTime: 11,
          endTime: 13,
        },
        {
          startTime: 15,
          endTime: 17,
        },
        {
          startTime: 18,
          endTime: 20,
        },
      ],
      status: 'open',
    },
    {
      day: 6,
      times: [],
      status: 'closed',
    },
  ],
};
